import Request from '../../utilities/Request';
import { refreshData } from "./dashboard.js";
import Swal from 'sweetalert2';

export const BEGIN_SHARE_BUDGET_BY_EMAIL_BEGIN = 'BEGIN_SHARE_BUDGET_BY_EMAIL_BEGIN';
export const BEGIN_SHARE_BUDGET_BY_EMAIL_SUCCESS = 'BEGIN_SHARE_BUDGET_BY_EMAIL_SUCCESS';
export const BEGIN_SHARE_BUDGET_BY_EMAIL_FAIL = 'BEGIN_SHARE_BUDGET_BY_EMAIL_FAIL';

export const END_SHARE_BUDGET_BEGIN = 'END_SHARE_BUDGET_BEGIN';
export const END_SHARE_BUDGET_SUCCESS = 'END_SHARE_BUDGET_SUCCESS';
export const END_SHARE_BUDGET_FAIL = 'END_SHARE_BUDGET_FAIL';

export const GET_SHARED_BUDGETS_BEGIN = 'GET_SHARED_BUDGETS_BEGIN';
export const GET_SHARED_BUDGETS_SUCCESS = 'GET_SHARED_BUDGETS_SUCCESS';
export const GET_SHARED_BUDGETS_FAIL = 'GET_SHARED_BUDGETS_FAIL';

export const ACCEPT_BUDGET_INVITE_BEGIN = 'ACCEPT_BUDGET_INVITE_BEGIN';
export const ACCEPT_BUDGET_INVITE_SUCCESS = 'ACCEPT_BUDGET_INVITE_SUCCESS';
export const ACCEPT_BUDGET_INVITE_FAIL = 'ACCEPT_BUDGET_INVITE_FAIL';

export const REJECT_BUDGET_INVITE_BEGIN = 'REJECT_BUDGET_INVITE_BEGIN';
export const REJECT_BUDGET_INVITE_SUCCESS = 'REJECT_BUDGET_INVITE_SUCCESS';
export const REJECT_BUDGET_INVITE_FAIL = 'REJECT_BUDGET_INVITE_FAIL';

export const CHANGE_ACTIVE_BUDGET_BEGIN = 'CHANGE_ACTIVE_BUDGET_BEGIN';
export const CHANGE_ACTIVE_BUDGET_SUCCESS = 'CHANGE_ACTIVE_BUDGET_SUCCESS';
export const CHANGE_ACTIVE_BUDGET_FAIL = 'CHANGE_ACTIVE_BUDGET_FAIL';

export const changeActiveBudget = (budgetId) => (dispatch, getState) => {
	dispatch({
		type: CHANGE_ACTIVE_BUDGET_BEGIN,
		payload: budgetId,
	});
	return Request.apiv1Post('settings/change_active_budget', { budget_id: budgetId })
		.then((response) => {
			console.log('the response', response);
			dispatch({
				type: CHANGE_ACTIVE_BUDGET_SUCCESS,
				payload: {
					active_budget: response.active_budget,
					budgets: response.budgets
				},
			});
			dispatch(refreshData());
		})
		.catch(async(error) => {
			console.error(error);
			dispatch({
				type: CHANGE_ACTIVE_BUDGET_FAIL
			});
			error = await Request.parseError(error);
			if(error) {
				alert(error);
			}
		});
};

export const acceptBudgetInvite = (budgetId) => (dispatch, getState) => {
	return dispatch(budgetShareAction(
		ACCEPT_BUDGET_INVITE_BEGIN,
		ACCEPT_BUDGET_INVITE_SUCCESS,
		ACCEPT_BUDGET_INVITE_FAIL,
		{ budget_id: budgetId, accept: true },
		'settings/respond_to_budget_invite',
	));
};

export const rejectBudgetInvite = (budgetId) => (dispatch, getState) => {
	return dispatch(budgetShareAction(
		REJECT_BUDGET_INVITE_BEGIN,
		REJECT_BUDGET_INVITE_SUCCESS,
		REJECT_BUDGET_INVITE_FAIL,
		{ budget_id: budgetId, accept: false },
		'settings/respond_to_budget_invite',
	));
};

export const getSharedBudgets = () => (dispatch, getState) => {
	return dispatch(budgetShareAction(
		GET_SHARED_BUDGETS_BEGIN,
		GET_SHARED_BUDGETS_SUCCESS,
		GET_SHARED_BUDGETS_FAIL,
		{},
		'settings/shared_budgets',
		Request.apiv1Get
	));
};

export const endBudgetShareByEmail = (budgetId, email) => (dispatch, getState) => {
	return dispatch(budgetShareAction(
		END_SHARE_BUDGET_BEGIN,
		END_SHARE_BUDGET_SUCCESS,
		END_SHARE_BUDGET_FAIL,
		{ budget_id: budgetId, email: email, share: false },
		'settings/shared_budgets',
	));
};

export const shareBudgetWithEmail = (budgetId, email) => (dispatch, getState) => {
	return dispatch(budgetShareAction(
		BEGIN_SHARE_BUDGET_BY_EMAIL_BEGIN,
		BEGIN_SHARE_BUDGET_BY_EMAIL_SUCCESS,
		BEGIN_SHARE_BUDGET_BY_EMAIL_FAIL,
		{ budget_id: budgetId, email: email, share: true },
		'settings/shared_budgets',
	));
};

const budgetShareAction = (
	begin,
	success,
	fail,
	data,
	url = 'settings/shared_budgets',
	requestFunction = Request.apiv1Post,
) => (dispatch, getState) => {
	dispatch({
		type: begin,
		payload: data.budget_id
	});

	return requestFunction(url, data)
		.then((response) => {
			dispatch({
				type: success,
				payload: response.budgets
			});
		})
		.catch(async(error) => {
			console.error(error);
			dispatch({
				type: fail
			});
			error = await Request.parseError(error);
			if(error) {
				Swal.fire(error);
			}
			throw error;
		});
};